import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { SupportSessionAttributes } from "@models/supportSession.model";

@Injectable({
    providedIn: "root",
})
export class SupportChatApiService {
    private readonly endpoint = `${environment.apiUrlBasePath}/support`;

    constructor(private http: HttpClient) {}

    public getSession(publicId?: string): Observable<SupportSessionAttributes> {
        const params = publicId ? { params: { publicId } } : {};
        return this.http.get<SupportSessionAttributes>(`${this.endpoint}/sessions`, params);
    }
}
